/**
 * POPIN - Add to bag
 *
 * @overview File used to handle the "add to bag" popin.
 *
*/

// Imports
import GlobalVars from '../GlobalVars';
import {
  cartItemRemovedEventName
} from '../Events';
import AjaxURL from '../AjaxURL';
import {
  create,
  remove,
  open,
  close,
} from './popin';

let $popin = {};

/**
 * Open add to bag popin
*/
function ajaxCall(askusList, quantitySelected) {
  return $.ajax({
    url: AjaxURL.getAddToBagPopin,
    data: {
      task: 'getaddtobagpopin',
      c: GlobalVars.C,
      l: GlobalVars.L,
      skus: askusList,
      quantity: quantitySelected,
    },
    dataType: 'html',
    type: 'GET',
    traditional: true,
    cache: false
  });
}

function addToBagPopin(askusList, quantity) {
  ajaxCall(askusList, quantity).done((content) => {
    const hasOverlay = GlobalVars.IsMobile;
    $popin = create(content, 'addToBag', {
      replace: true,
      contentWithHeader: true,
      top: true,
      container: '#header',
      overlay: hasOverlay,
    });

    if ($popin.length) {
      open($popin);
    }

    // Remove popin on associated product removal from cart
    $(document).on(cartItemRemovedEventName, (e, ...args) => {
      if (askusList.indexOf(args[0][0].sku) > -1) {
        remove('addToBag');
      }
    });
  });
}

function openAddToBagPopin() {
  if ($popin.length) {
    $popin.removeAttr('style');
    open($popin);
    return true;
  }

  return false;
}

function closeAddToBagPopin() {
  if ($popin.length) {
    $popin.css('display', 'none');
    close($popin);
    return true;
  }

  return false;
}

// Named exports - Functions
export {
  addToBagPopin,
  openAddToBagPopin,
  closeAddToBagPopin,
};



// WEBPACK FOOTER //
// ./js/common/organism/popin.addtobag.js